import React from "react"
import { Redirect } from "react-router-dom"

// Profile
import UserProfile from "../pages/Authentication/user-profile"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Dashboard
import Dashboard from "../pages/Dashboard/index"
// import Appointment from "../pages/Appointment/index"
// import Accounts from "../pages/Accounts/index"
import Patient from "../pages/Shipments/index"
import Settings from "pages/Settings"
import Reports from "pages/Reports"
import TrackingStatus from "pages/Shipments/tracking"
import ScheduledTracking from "pages/Dashboard/trackingList"

const authProtectedRoutes = [
  { path: "/dashboard", component: Dashboard },
  // { path: "/accounts", component: Accounts },
  { path: "/shipments", component: Patient },
  { path: "/reports/:category?", component: Reports },
  { path: "/settings/:category?", component: Settings },

  // //profile
  { path: "/profile", component: UserProfile },
  
  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  { path: "/", exact: true, component: () => <Redirect to="/dashboard" /> },
  { path: "/status/:trackingId", component: TrackingStatus },
  { path: "/shedule", component: ScheduledTracking },
]

const publicRoutes = [
  { path: "/track/:trackingId", component: TrackingStatus },
  // { path: "/track-shipment/:trackingId", component: TrackingStatus },
  { path: "/", component: Login },
  { path: "/admin", component: Login },
  { path: "/logout", component: Logout },
  { path: "/forgot-password", component: ForgetPwd },
  { path: "/register", component: Register },
]

export { publicRoutes, authProtectedRoutes }
